module.exports = __webpack_public_path__ + "static/media/3-8.3c172060.mp3";